<span *ngIf="left">{{left}}</span>
